export default "__VITE_ASSET__DP$rZ2j6__"